module.exports = __webpack_public_path__ + "img/tag_blank_back.40179a00.svg";